import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Unstable_Grid2 as Grid } from '@mui/material';

import { InfoField, ChipBox } from '@occc/ui-design-system';
import { routeCreator as productCategoryRouteCreator } from '@occc-app/routes/ProductCategory/utils';

import { titleByProductInterestsControl, titleByProductInterestsMatch } from './constants';

import { ProductInterestsAttribute } from '../../types';

interface ProductInterestsDetailsProps {
  productInterests: ProductInterestsAttribute;
}

export const ProductInterestsDetails: React.FC<ProductInterestsDetailsProps> = ({
  productInterests,
}) => {
  const navigate = useNavigate();

  const preferenceChipItems = productInterests.productCategories?.map((category) => ({
    id: category.id,
    name: category.name,
  }));

  const onChipClick = React.useCallback(
    (id: string) => {
      navigate(productCategoryRouteCreator.details(id));
    },
    [navigate],
  );

  return (
    <>
      <Grid xs={12} sm={6} md={3}>
        <InfoField
          label='Product interest'
          value={`${
            titleByProductInterestsControl[productInterests.prefer]
          } ${titleByProductInterestsMatch[productInterests.match].toLowerCase()}`}
        />
      </Grid>

      <Grid xs={12} sm={6} md={3}>
        <InfoField
          label='Product groups to purchase'
          value={
            preferenceChipItems && (
              <ChipBox
                items={preferenceChipItems}
                onClick={onChipClick}
                sx={{
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1,
                }}
              />
            )
          }
        />
      </Grid>
    </>
  );
};
